import axios from "axios";
import Cookies from "js-cookie";

export default {
    init() {
        axios.defaults.headers.common["Content-Type"] = "application/json";
        axios.defaults.headers.common["Accept"] = "application/json";
        axios.defaults.headers.common["X-CSRF-Token"] =
            Cookies.get("csrfToken");
        axios.defaults.headers.common["csrfToken"] = Cookies.get("csrfToken");
        axios.defaults.headers.common["EVENTSETTING"] =
            Cookies.get("EVENTSETTING");
        axios.defaults.headers.common["cart"] = Cookies.get("cart");
    },

    get(resource, options = {}) {
        return axios.get(`${resource}`, options);
    },

    post(resource, options = {}) {
        return axios.post(`${resource}`, options);
    },
};
